import React from "react"

const RowItem = ({ label, value }) => (
  <div className="d-flex justify-content-between gap-3 py-1">
    <span className="text-muted">{label}</span>
    <strong className="text-end">{value || "-"}</strong>
  </div>
)

const AppointmentRescheduleSummary = ({ appointmentData }) => {
  const currentDate = appointmentData?.date ? new Date(appointmentData.date).toLocaleDateString() : "-"
  const currentTime = appointmentData?.time || "-"

  return (
    <div className="border rounded p-3 bg-light">
      <RowItem label="Pet Name" value={appointmentData?.petObjectId?.fullName || appointmentData?.petName} />
      <RowItem label="Parent/Owner Name" value={appointmentData?.parentId?.fullName || appointmentData?.parentName} />
      <RowItem label="Assigned Vet" value={appointmentData?.doctorId?.fullName || appointmentData?.doctorName} />
      <RowItem label="Current Date" value={currentDate} />
      <RowItem label="Current Time" value={currentTime} />
      <RowItem label="Current Status" value={appointmentData?.status} />
    </div>
  )
}

export default AppointmentRescheduleSummary
